import React from 'react';
import { Link } from 'react-router-dom';

const ContractList = props => {
    if (!props.contracts) {
        return (
            <div className='broad'>Loading...</div>
        )
    }

    if (props.contracts.length === 0) {
        return (
          <div className='empty'>
            No contracts...
          </div>
        );
    }

    return (
        <div>
            <table className="dataTable">
                <thead>
                    <tr>
                        <th>Key</th>
                        <th>Name</th>
                        <th>Symbol</th>
                        <th>Contract</th>
                        <th>Type</th>
                        <th>Generated</th>
                        <th>Show</th>
                        <th>Created</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        props.contracts.map(item => {
                            return (
                                <tr key={item.key}>
                                    <td className="keyfield"><Link to={`/contracts/${item.key}`}>{item.key}</Link></td>
                                    <td>{item.name}</td>
                                    <td>{item.symbol}</td>
                                    <td>{item.contract}</td>
                                    <td>{item.type}</td>
                                    <td>{item.generated_status}</td>
                                    <td>{item.display ? 'Yes' : 'No'}</td>
                                    <td>{item.created}</td>
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
        </div>
    );
};

export default ContractList;



// WEBPACK FOOTER //
// ./src/components/widgets/ContractList.js